import voyageArrivalWindowDataToJson from "../arrival_window/db/mapper_to_json";
import voyageConstraintsDataToJson from "../constraints/db/mapper_to_json";
import voyageFuelDataToJson from "../fuel/db/mapper_to_json";
import voyageTweaksDataToJson from "../tweaks/db/mapper_to_json";

export default function voyageOptionsToJson(voyageOptions) {
    return {
        "max_service_speed": voyageOptions.maxServiceSpeed,
        "min_service_speed": voyageOptions.minServiceSpeed,
        "max_cruise_speed": voyageOptions.maxCruiseSpeed,
        "min_cruise_speed": voyageOptions.minCruiseSpeed,
        "max_service_power": voyageOptions.maxServicePower,
        "min_service_power": voyageOptions.minServicePower,
        "max_service_rpm": voyageOptions.maxServiceRpm,
        "min_service_rpm": voyageOptions.minServiceRpm,
        "vessel_draft": voyageOptions.vesselDraft,
        "etd_window": voyageOptions.etdWindow,
        "navigation_mode": voyageOptions.navigationMode,
        "use_tss": voyageOptions.useTss,
        "use_eca": voyageOptions.useEca,
        "use_trs": voyageOptions.useTrs,
        "use_suez": voyageOptions.useSuez,
        "use_panama": voyageOptions.usePanama,
        "use_kiel": voyageOptions.useKiel,
        "use_taiwan_strait": voyageOptions.useTaiwanStrait,
        "avoid_piracy": voyageOptions.avoidPiracy,
        "use_datasets": voyageOptions.useDatasets,
        "keep_voyage_data": voyageOptions.keepVoyageData,
        "land_proximity": voyageOptions.landProximity,
        "daily_rate": voyageOptions.dailyRate,
        "dta": voyageOptions.dta,
        "operational_mode": voyageOptions.operationalMode,
        "fuel": voyageOptions.fuel.map((fuel) => voyageFuelDataToJson(fuel)),
        "constraints": voyageConstraintsDataToJson(voyageOptions.constraints),
        "validator": null,
        "tweaks": voyageOptions.tweaks != null && voyageOptions.tweaks != undefined ? voyageTweaksDataToJson(voyageOptions.tweaks) : null,
        "arrival_window": voyageOptions.arrivalWindow != null && voyageOptions.arrivalWindow != undefined ? voyageArrivalWindowDataToJson(voyageOptions.arrivalWindow) : null
    }
}

